import { render } from "./ArticlesBlock.vue?vue&type=template&id=56bc7a85&scoped=true"
import script from "./ArticlesBlock.vue?vue&type=script&lang=js"
export * from "./ArticlesBlock.vue?vue&type=script&lang=js"

import "./ArticlesBlock.vue?vue&type=style&index=0&id=56bc7a85&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56bc7a85"]])

export default __exports__